<script>
    import { navigate } from '../router.js';
    import { path } from '../router.js';

    let menuOpen = false;

    function go(e, to) {
        e.preventDefault();
        menuOpen = false;
        navigate(to);
    }

    function toggleMenu() {
        menuOpen = !menuOpen;
    }

    // Close menu on path change (e.g. browser back)
    $: if ($path) menuOpen = false;
</script>

<header>
    <a href="/" class="site-name" on:click={e => go(e, '/')}>Hanna Tiina Pekk</a>

    <!-- Desktop nav -->
    <nav class="desktop-nav">
        <a href="/" class:active={$path === '/'} on:click={e => go(e, '/')}>Home</a>
        <a href="/collections" class:active={$path.startsWith('/collections')} on:click={e => go(e, '/collections')}>Collections</a>
        <a href="/about" class:active={$path === '/about'} on:click={e => go(e, '/about')}>About</a>
    </nav>

    <!-- Burger button (mobile) -->
    <button class="burger" aria-label="Menu" aria-expanded={menuOpen} on:click={toggleMenu}>
        <span class="burger-line" class:open={menuOpen}></span>
        <span class="burger-line" class:open={menuOpen}></span>
        <span class="burger-line" class:open={menuOpen}></span>
    </button>
</header>

<!-- Mobile dropdown -->
{#if menuOpen}
    <div class="mobile-menu">
        <a href="/" class:active={$path === '/'} on:click={e => go(e, '/')}>Home</a>
        <a href="/collections" class:active={$path.startsWith('/collections')} on:click={e => go(e, '/collections')}>Collections</a>
        <a href="/about" class:active={$path === '/about'} on:click={e => go(e, '/about')}>About</a>
    </div>
    <div class="mobile-menu-backdrop" on:click={() => menuOpen = false}></div>
{/if}

<style>
    header {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 60px;
        background: #f8f6f3;
        box-shadow: 0 2px 8px rgba(0,0,0,0.05);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 2rem;
        box-sizing: border-box;
        z-index: 1000;
    }

    .site-name {
        font-size: 1rem;
        font-weight: 600;
        color: #1a1a1a;
        text-decoration: none;
        letter-spacing: 0.04em;
        white-space: nowrap;
    }

    /* Desktop nav */
    .desktop-nav {
        display: flex;
        gap: 1.8rem;
    }

    .desktop-nav a {
        font-size: 0.72rem;
        letter-spacing: 0.14em;
        text-transform: uppercase;
        color: #888;
        text-decoration: none;
        transition: color 0.2s;
    }

    .desktop-nav a:hover,
    .desktop-nav a.active {
        color: #1a1a1a;
    }

    /* Burger button */
    .burger {
        display: none;
        flex-direction: column;
        justify-content: center;
        gap: 5px;
        width: 32px;
        height: 32px;
        padding: 0;
        background: none;
        border: none;
        cursor: pointer;
    }

    .burger-line {
        display: block;
        width: 22px;
        height: 1.5px;
        background: #1a1a1a;
        transition: transform 0.2s, opacity 0.2s;
    }

    .burger-line:nth-child(1).open { transform: translateY(6.5px) rotate(45deg); }
    .burger-line:nth-child(2).open { opacity: 0; }
    .burger-line:nth-child(3).open { transform: translateY(-6.5px) rotate(-45deg); }

    /* Mobile dropdown */
    .mobile-menu {
        position: fixed;
        top: 60px;
        left: 0;
        width: 100%;
        background: #f8f6f3;
        display: flex;
        flex-direction: column;
        padding: 0.5rem 0 1rem;
        z-index: 999;
        box-shadow: 0 4px 12px rgba(0,0,0,0.07);
    }

    .mobile-menu a {
        padding: 0.9rem 2rem;
        font-size: 0.72rem;
        letter-spacing: 0.14em;
        text-transform: uppercase;
        color: #888;
        text-decoration: none;
        transition: color 0.2s;
    }

    .mobile-menu a:hover,
    .mobile-menu a.active {
        color: #1a1a1a;
    }

    .mobile-menu-backdrop {
        position: fixed;
        inset: 0;
        top: 60px;
        z-index: 998;
    }

    @media (max-width: 700px) {
        .desktop-nav { display: none; }
        .burger {
            display: flex;
            position: absolute;
            right: 1rem;
        }
        .site-name {
            flex: 1;
            text-align: center;
        }
    }
</style>
